module.exports = __webpack_public_path__ + "static/media/piano-01-md.ec9e7838.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/piano-01-md.jpg
// module id = 570
// module chunks = 0